// extracted by mini-css-extract-plugin
export default {"wrap":"SideBar_wrap__q90nT","logo":"SideBar_logo__7SIiB","nav":"SideBar_nav__8P9Wg","toggle":"SideBar_toggle__rzP2n","narrow":"SideBar_narrow__KjG8g","wide":"SideBar_wide__zWcPj"};